import * as Yup from 'yup'

import { FC, HTMLAttributes, useEffect } from "react"

import { FieldError } from '../../../../../widgets'
import { IEntity } from '../../../../../base/types'
import { ITextBoxProps } from './ITextBoxProps'
import clsx from 'clsx'
import { useFormContext } from '../../form'
import { useFormikContext } from "formik"
import { useTextBoxValidationSchema } from './TextBoxValidationSchema'

interface ITextBoxFieldProps extends HTMLAttributes<HTMLInputElement>, ITextBoxProps {
    name: string
}

export const TextBoxField: FC<ITextBoxFieldProps> = (props) => {
    const { id, name, placeholder, className, title, readOnly, disabled } = props
    const shape = useTextBoxValidationSchema(props)
    const { getFieldProps, errors, touched } = useFormikContext<IEntity>() || {}
    const { updateSchema } = useFormContext()

    useEffect(() => {
        if (!name || !shape) return;

        const schema = Yup.object().shape({ [name]: shape });
        updateSchema(schema);

        // eslint-disable-next-line
    }, [name, shape])

    let fieldProps = name ? getFieldProps(`['${name}']`) : { value: '' }
    if (fieldProps.value === undefined)
        fieldProps = { ...fieldProps, value: ('') }

    return <>
        <input
            id={id}
            {...fieldProps}
            title={title}
            className={clsx(className, "form-control form-control-sm")}
            placeholder={placeholder}
            readOnly={readOnly}
            disabled={disabled}
        />
        <FieldError show={touched[name] && !!errors[name]} message={`${errors[name]}`} />
    </>
}
